export const SET_IS_LOADING_APP = 'SET_IS_LOADING_APP'
export const SET_SNACKBAR_SHOWING = 'SET_SNACKBAR_SHOWING'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_HEADER = 'SET_HEADER'
